import {noop} from '@github-ui/noop'
import {createContext, memo, Profiler as ReactProfiler, type ProfilerOnRenderCallback, useContext} from 'react'

import {useAppScopedProfilerCollector} from './profiler-collector'

const ProfilerContext = createContext<ProfilerOnRenderCallback | null>(null)
export const ProfilerProvider = memo(function ProfilerProvider({
  isDataRouterEnabled,
  appName,
  children,
}: {
  isDataRouterEnabled: boolean
  appName: string
  children: React.ReactNode
}) {
  const {onRender} = useAppScopedProfilerCollector({appName, isDataRouterEnabled})
  return <ProfilerContext.Provider value={onRender}>{children}</ProfilerContext.Provider>
})

const useProfilerOnRender = () => {
  const contextValue = useContext(ProfilerContext)
  return contextValue
}

export const Profiler = memo(function Profiler({id, children}: {id: string; children: React.ReactNode}) {
  const profilerOnRender = useProfilerOnRender()
  return (
    <ReactProfiler id={id} onRender={profilerOnRender ?? noop}>
      {children}
    </ReactProfiler>
  )
})

try{ ProfilerContext.displayName ||= 'ProfilerContext' } catch {}
try{ ProfilerProvider.displayName ||= 'ProfilerProvider' } catch {}
try{ Profiler.displayName ||= 'Profiler' } catch {}